import { createSelector } from 'reselect'
import { getRawId } from 'util/globalId'
import { selectCurrentUserGlobalId } from 'ducks/currentUser/selectors/selectCurrentUserGlobalId'
import { selectCurrentConversation } from './selectCurrentConversation'

export const selectCurrentConversationIsFollowing = createSelector(
  selectCurrentConversation,
  selectCurrentUserGlobalId,
  (ticket, currentUserGid) => {
    if (!ticket?.followers || !currentUserGid) return false

    // Extract raw ID for comparison (handles both GQL and legacy formats)
    const currentUserRawId = getRawId(currentUserGid)

    return ticket.followers.some(followerId => {
      const followerRawId = getRawId(followerId)
      return followerRawId === currentUserRawId
    })
  }
)
